module.exports = __webpack_public_path__ + "static/flags/SX-d0eb5c5d64fe9a6324c47884de4db706.gif";